import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/tmp.ddb1SSGpvu/src/app/(dynamic)/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/tmp.ddb1SSGpvu/src/app/(dynamic)/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/tmp.ddb1SSGpvu/src/components/atoms/render-counter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StateProvider"] */ "/tmp/tmp.ddb1SSGpvu/src/components/providers/state-provider.tsx");
